import type {
  StorefrontTagReOrderRequestType,
  StorefrontTagReOrderResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

type StorefrontTagReOrderMutationData = StorefrontTagReOrderRequestType & {
  storefrontTagId: number;
};

export const useStorefrontTagReOrder = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: ({
      storefrontTagId,
      ...data
    }: StorefrontTagReOrderMutationData) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `storefront-tags/${storefrontTagId}/re-order`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as StorefrontTagReOrderResponseType,
      ),
    onSettled: (_data, _error, variables) => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.StorefrontTags],
      });
      if (variables) {
        queryClient.invalidateQueries({
          queryKey: [
            user?.uid,
            business?.id,
            ServerStateKeys.StorefrontTags,
            variables.storefrontTagId,
          ],
        });
      }
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Products],
      });
    },
  });
};
